import React from "react";
import styled from "styled-components";
import { Row } from "common/components";
import { ControlLabel, Label } from "components/bootstrap";
import { IconButton, Icon } from "components/common";
import useOwnerAction from "security-app/components/SecurityEvents/Alerts/hooks/useOwnerAction";
const FlexLabel = styled(Label)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
const StyledIcon = styled(Icon)`
  cursor: pointer;
`;
const OwnerAction = ({ securityEvent }) => {
  const { onRemoveOwner, selectOwner, currentOwnerName } = useOwnerAction(securityEvent);
  return /* @__PURE__ */ React.createElement(Row, { $gap: "xs", $align: "center", $width: "auto" }, /* @__PURE__ */ React.createElement(ControlLabel, { style: { margin: 0 } }, "Owner"), !!currentOwnerName && /* @__PURE__ */ React.createElement(FlexLabel, null, currentOwnerName, /* @__PURE__ */ React.createElement(StyledIcon, { name: "close", onClick: onRemoveOwner })), !!currentOwnerName || /* @__PURE__ */ React.createElement(IconButton, { name: "add", onClick: selectOwner, title: "Add owner" }));
};
export default OwnerAction;
